import { useNavigateToSection } from './navigationUtils';

export const useHandleClick = () => {
  const navigateToSection = useNavigateToSection();

  const handleClick = (event, sectionId) => {
    event.preventDefault();
    navigateToSection(sectionId);
  };

  return handleClick;
};